import { useState } from 'react';
import { adminApi, setAdminToken } from '@/api/admin.api';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Logo } from '@/components/custom/logo';

export function AdminLogin() {
  const [step, setStep] = useState<'credentials' | 'totp'>('credentials');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tempToken, setTempToken] = useState<string | null>(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      setError(null);
      const res = await adminApi.login({ email, password });
      if (res.requiresTOTP && res.tempToken) {
        setTempToken(res.tempToken);
        setStep('totp');
      } else if (res.accessToken) {
        setAdminToken(res.accessToken);
        navigate('/admin/dashboard');
      }
    } catch (e: any) {
      setError(e.message);
    }
  };

  const handleVerify = async () => {
    try {
      setError(null);
      if (!tempToken) throw new Error('Missing temp token');
      const res = await adminApi.verifyTOTP({ tempToken, code });
      setAdminToken(res.accessToken);
      navigate('/admin/dashboard');
    } catch (e: any) {
      setError(e.message);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-24 space-y-6">
      <div className="flex justify-center mb-6"><Logo theme="light" size={60} /></div>
      <h1 className="text-2xl font-bold text-center">Admin Console</h1>
      {step === 'credentials' ? (
        <div className="space-y-4">
          <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button onClick={handleLogin}>Login</Button>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </div>
      ) : (
        <div className="space-y-4">
          <p>Enter your 6-digit TOTP code</p>
          <Input placeholder="123456" value={code} onChange={(e) => setCode(e.target.value)} />
          <div className="flex gap-2">
            <Button onClick={() => setStep('credentials')} variant="secondary">Back</Button>
            <Button onClick={handleVerify}>Verify</Button>
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </div>
      )}
    </div>
  );
}

